import { render, staticRenderFns } from "./Dequeue.vue?vue&type=template&id=2f87213b&scoped=true&"
import script from "./Dequeue.vue?vue&type=script&lang=js&"
export * from "./Dequeue.vue?vue&type=script&lang=js&"
import style0 from "./Dequeue.vue?vue&type=style&index=0&id=2f87213b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f87213b",
  null
  
)

export default component.exports